import React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './PartnerNewGameAdd.module.scss';
import clsx from 'clsx';
import Input from '../Input/Input';
import Button from '../Button/Button';
import { useForm } from 'react-hook-form';
import { gamePartnerCreate } from '../../redux/actions/game/gamePartnerCreate';
const PartnerNewGameAdd = ({ onCreate }) => {
  const form = useForm();
  // const dispatch = useDispatch();

  const onSubmit = (data) => {
    onCreate(data);
  };

  return (
    <>
      <Input type={'text'} className={clsx(styles.gameNameInput)} name="name" form={form} label="Название игры" />
      <Button className={clsx(styles.addButton)} type="success" onClick={form.handleSubmit(onSubmit)}>
        Добавить
      </Button>
    </>
  );
};

export default PartnerNewGameAdd;
